module.exports = __webpack_public_path__ + "4c2c379f607fe46e0cec999154ea0ba8.svg";